<!-- Hero Carousel Section -->
<div id="heroCarousel" class="carousel slide hero-carousel" data-bs-ride="carousel">
    <div class="carousel-inner">
        <!-- Slide 1: Fournisseur -->
        <div class="carousel-item active" data-bs-interval="5000">
            <div class="hero-slide">
                <div class="hero-background"></div>
                <div class="container">
                    <div class="row align-items-center">
                        <div class="col-lg-6">
                            <div class="hero-content">
                                <div class="hero-badge">
                                    <i class="icofont-users"></i>
                                    <span>Fournisseur</span>
                                </div>
                                <h1 class="hero-title">
                                    Devenir <span class="highlight">Fournisseur</span>
                                </h1>
                                <p class="hero-description">
                                    Promouvez votre entreprise et trouvez des offres exclusives. 
                                    Rejoignez notre réseau de fournisseurs qualifiés et développez 
                                    votre activité avec des opportunités ciblées.
                                </p>
                                <div class="hero-buttons">
                                    <a class="btn btn-primary" routerLink="/login">
                                        <i class="icofont-login"></i>
                                        Connexion
                                    </a>
                                    <a class="btn btn-outline-primary" routerLink="/create-account">
                                        <i class="icofont-user-plus"></i>
                                        Inscription
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="hero-image">
                                <div class="image-container">
                                    <img src="assets/img/upload/home/section-2.png" alt="Fournisseur BSTP" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Slide 2: Acheteur -->
        <div class="carousel-item" data-bs-interval="5000">
            <div class="hero-slide">
                <div class="hero-background"></div>
                <div class="container">
                    <div class="row align-items-center">
                        <div class="col-lg-6">
                            <div class="hero-content">
                                <div class="hero-badge">
                                    <i class="icofont-search-1"></i>
                                    <span>Acheteur</span>
                                </div>
                                <h1 class="hero-title">
                                    Devenir <span class="highlight">Acheteur</span>
                                </h1>
                                <p class="hero-description">
                                    Trouvez les entreprises guinéennes validées pour exécuter votre travail. 
                                    Accédez à un réseau de fournisseurs qualifiés et bénéficiez de services 
                                    professionnels de qualité.
                                </p>
                                <div class="hero-buttons">
                                    <a class="btn btn-primary" routerLink="/login">
                                        <i class="icofont-login"></i>
                                        Connexion
                                    </a>
                                    <a class="btn btn-outline-primary" routerLink="/create-account">
                                        <i class="icofont-user-plus"></i>
                                        Inscription
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="hero-image">
                                <div class="image-container">
                                    <img src="assets/img/upload/home/section-2.png" alt="Acheteur BSTP" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Carousel Controls -->
    <button class="carousel-control-prev" type="button" data-bs-target="#heroCarousel" data-bs-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Précédent</span>
    </button>
    <button class="carousel-control-next" type="button" data-bs-target="#heroCarousel" data-bs-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Suivant</span>
    </button>

    <!-- Carousel Indicators -->
    <div class="carousel-indicators">
        <button type="button" data-bs-target="#heroCarousel" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
        <button type="button" data-bs-target="#heroCarousel" data-bs-slide-to="1" aria-label="Slide 2"></button>
    </div>
</div>

<!-- Counter Section -->
<section class="counter-section" *ngIf="appSettingService.value != null">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 text-center mb-5">
                <div class="counter-header">
                    <h2>Nos Chiffres Clés</h2>
                    <p>Découvrez l'impact de BSTP sur l'écosystème de la sous-traitance en Guinée</p>
                </div>
            </div>
        </div>
        
        <div class="row">
            <!-- Fournisseurs -->
            <div class="col-lg-3 col-md-6 mb-4">
                <div class="counter-card">
                    <div class="counter-icon">
                        <i class="flaticon-curriculum"></i>
                    </div>
                    <div class="counter-content">
                        <div class="counter-number">
                            <span class="counter-value">+{{ appSettingService.value.total_supplier }}</span>
                        </div>
                        <h3>Fournisseurs</h3>
                        <p>Entreprises qualifiées</p>
                    </div>
                </div>
            </div>

            <!-- Acheteurs -->
            <div class="col-lg-3 col-md-6 mb-4">
                <div class="counter-card">
                    <div class="counter-icon">
                        <i class="flaticon-enterprise"></i>
                    </div>
                    <div class="counter-content">
                        <div class="counter-number">
                            <span class="counter-value">+{{ appSettingService.value.total_buyer }}</span>
                        </div>
                        <h3>Acheteurs</h3>
                        <p>Donneurs d'ordres</p>
                    </div>
                </div>
            </div>

            <!-- Appels d'offre -->
            <div class="col-lg-3 col-md-6 mb-4">
                <div class="counter-card">
                    <div class="counter-icon">
                        <i class="flaticon-businessman-paper-of-the-application-for-a-job"></i>
                    </div>
                    <div class="counter-content">
                        <div class="counter-number">
                            <span class="counter-value">+{{ appSettingService.value.total_request }}</span>
                        </div>
                        <h3>Appels d'offre</h3>
                        <p>Opportunités créées</p>
                    </div>
                </div>
            </div>

            <!-- Organismes -->
            <div class="col-lg-3 col-md-6 mb-4">
                <div class="counter-card">
                    <div class="counter-icon">
                        <i class="flaticon-enterprise"></i>
                    </div>
                    <div class="counter-content">
                        <div class="counter-number">
                            <span class="counter-value">+{{ appSettingService.value.total_organisme }}</span>
                        </div>
                        <h3>Organismes</h3>
                        <p>De soutien partenaires</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!--section class="category-area ptb-100">
    <div class="container">
        <div class="section-title">
            <h2>Choose Your Desire Category</h2>
        </div>

        <div class="row">
            <div class="col-sm-3 col-lg-3 category-border">
                <div class="category-item">
                    <i class="flaticon-settings"></i>
                    <a routerLink="/">Technical Support</a>
                </div>
            </div>

            <div class="col-sm-3 col-lg-3 category-border">
                <div class="category-item category-two">
                    <i class="flaticon-layers"></i>
                    <a routerLink="/">Business Development</a>
                </div>
            </div>

            <div class="col-sm-3 col-lg-3 category-border">
                <div class="category-item category-three">
                    <i class="flaticon-house"></i>
                    <a routerLink="/">Real Estate Business</a>
                </div>
            </div>

            <div class="col-sm-3 col-lg-3 category-border">
                <div class="category-item category-four">
                    <i class="flaticon-analysis"></i>
                    <a routerLink="/">Share Maeket Analysis</a>
                </div>
            </div>

            <div class="col-sm-3 col-lg-3 category-border-three">
                <div class="category-item category-five">
                    <i class="flaticon-sun"></i>
                    <a routerLink="/">Weather & Environment</a>
                </div>
            </div>

            <div class="col-sm-3 col-lg-3 category-border-two">
                <div class="category-item category-six">
                    <i class="flaticon-hand"></i>
                    <a routerLink="/">Finance & Banking Service</a>
                </div>
            </div>

            <div class="col-sm-3 col-lg-3 category-border-two">
                <div class="category-item category-seven">
                    <i class="flaticon-neural"></i>
                    <a routerLink="/">IT & Networing Sevices</a>
                </div>
            </div>

            <div class="col-sm-3 col-lg-3 category-border-two">
                <div class="category-item category-eight">
                    <i class="flaticon-dish"></i>
                    <a routerLink="/">Restaurant Services</a>
                </div>
            </div>

            <div class="col-sm-3 offset-sm-3 offset-lg-0 col-lg-3 category-border-two">
                <div class="category-item category-nine">
                    <i class="icofont-fire-burn"></i>
                    <a routerLink="/">Defence  & Fire Service</a>
                </div>
            </div>

            <div class="col-sm-3 col-lg-3">
                <div class="category-item category-ten">
                    <i class="flaticon-truck"></i>
                    <a routerLink="/">Home Delivery Services</a>
                </div>
            </div>
        </div>
    </div>
</section-->

<!-- Portal Section -->
<section class="portal-section pt-100 pb-100">
    <div class="container">
        <div class="portal-content">
            <div class="row align-items-center">
                <div class="col-lg-6 mb-5 mb-lg-0">
                    <div class="portal-visual">
                        <div class="image-grid">
                            <div class="image-item primary-image">
                                <img src="./assets/img/upload/home/section-1.png" alt="BSTP Portal" class="portal-img" />
                                <div class="image-overlay">
                                    <i class="icofont-ui-settings"></i>
                                </div>
                            </div>
                            <div class="image-item secondary-image">
                                <img src="./assets/img/upload/home/section-2.png" alt="BSTP Services" class="portal-img" />
                                <div class="image-overlay">
                                    <i class="icofont-handshake"></i>
                                </div>
                            </div>
                        </div>
                        
                        <div class="trust-badge">
                            <div class="badge-content">
                                <i class="icofont-shield-check"></i>
                                <span>100% Garantie</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-6">
                    <div class="portal-info">
                        <div class="section-header">
                            <div class="header-icon">
                                <i class="icofont-brand-target"></i>
                            </div>
                            <h2>BSTP offre des opportunités convertibles en direct</h2>
                            <p class="section-description">
                                BSTP vous ouvre les portes vers des opportunités commerciales directes, 
                                qu'elles émanent d'entreprises locales ou de multinationales. En plus, 
                                nous vous offrons un accompagnement technique pour renforcer vos compétences 
                                et vous conformer aux normes internationales.
                            </p>
                        </div>
                        
                        <div class="portal-features">
                            <div class="feature-item">
                                <div class="feature-icon">
                                    <i class="icofont-business-opportunity"></i>
                                </div>
                                <div class="feature-content">
                                    <h5>Opportunités Directes</h5>
                                    <p>Accédez à des appels d'offre exclusifs d'entreprises locales et multinationales</p>
                                </div>
                            </div>
                            
                            <div class="feature-item">
                                <div class="feature-icon">
                                    <i class="icofont-support"></i>
                                </div>
                                <div class="feature-content">
                                    <h5>Accompagnement Technique</h5>
                                    <p>Bénéficiez d'un support pour renforcer vos compétences et respecter les normes</p>
                                </div>
                            </div>
                        </div>
                        
                        <div class="portal-actions">
                            <a class="btn-primary" routerLink="/login">
                                <i class="icofont-login"></i>
                                <span>Connexion</span>
                                <i class="icofont-arrow-right"></i>
                            </a>
                            <a class="btn-secondary" routerLink="/create-account">
                                <i class="icofont-user-plus"></i>
                                <span>Inscription</span>
                                <i class="icofont-arrow-right"></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<div class="create-area">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-8">
                <div class="create-item">
                    <h2>Créez votre profil pour découvrir des milliers d'opportunités d'affaires, développer votre carrière et votre emploi !</h2>
                </div>
            </div>

            <div class="col-lg-4">
                <div class="create-item">
                    <div class="create-btn">
                        <a routerLink="/create-account">Adhérez maintenant</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<!--section class="job-area pt-100 pb-70">
    <div class="container">
        <div class="section-title">
            <h2>Recent Jobs</h2>
        </div>

        <div class="sorting-menu">
            <ul>
                <li class="filter active" data-filter="all">All</li>
                <li class="filter" data-filter=".web">New</li>
                <li class="filter" data-filter=".ui">Featured</li>
                <li class="filter" data-filter=".branding">Recent</li>
                <li class="filter" data-filter=".ux">Full Time</li>
                <li class="filter" data-filter=".wp">Part Time</li>
            </ul>
        </div>

        <div id="container">
            <div class="row">
                <div class="col-lg-6 mix web ui">
                    <div class="job-item">
                        <img src="assets/img/home-1/jobs/1.png" alt="Job">

                        <div class="job-inner align-items-center">
                            <div class="job-inner-left">
                                <h3>UI/UX Designer</h3>
                                <a routerLink="/company-details">Winbrans.com</a>
                                <ul>
                                    <li><i class="icofont-money-bag"></i> $20k - $25k</li>
                                    <li><i class="icofont-location-pin"></i> Location 210-27 Quadra, Market Street, Victoria Canada</li>
                                </ul>
                            </div>

                            <div class="job-inner-right">
                                <ul>
                                    <li><a routerLink="/create-account">Apply</a></li>
                                    <li><span>Full Time</span></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-6 mix ui web">
                    <div class="job-item">
                        <img src="assets/img/home-1/jobs/2.png" alt="Job">

                        <div class="job-inner align-items-center">
                            <div class="job-inner-left">
                                <h3>Android Developer</h3>
                                <a routerLink="/company-details">Infiniza.com</a>
                                <ul>
                                    <li><i class="icofont-money-bag"></i> $20k - $25k</li>
                                    <li><i class="icofont-location-pin"></i> Location 210-27 Quadra, Market Street, Victoria Canada</li>
                                </ul>
                            </div>

                            <div class="job-inner-right">
                                <ul>
                                    <li><a routerLink="/create-account">Apply</a></li>
                                    <li><span>Part Time</span></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-6 mix branding wp">
                    <div class="job-item">
                        <img src="assets/img/home-1/jobs/3.png" alt="Job">

                        <div class="job-inner align-items-center">
                            <div class="job-inner-left">
                                <h3>Senior Manager</h3>
                                <a routerLink="/company-details">Glovibo.com</a>
                                <ul>
                                    <li><i class="icofont-money-bag"></i> $20k - $25k</li>
                                    <li><i class="icofont-location-pin"></i> Location 210-27 Quadra, Market Street, Victoria Canada</li>
                                </ul>
                            </div>

                            <div class="job-inner-right">
                                <ul>
                                    <li><a routerLink="/create-account">Apply</a></li>
                                    <li><span>Intern</span></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-6 mix ux branding">
                    <div class="job-item ">
                        <img src="assets/img/home-1/jobs/4.png" alt="Job">

                        <div class="job-inner align-items-center">
                            <div class="job-inner-left">
                                <h3>Product Designer</h3>
                                <a routerLink="/company-details">Bizotic.com</a>
                                <ul>
                                    <li><i class="icofont-money-bag"></i> $20k - $25k</li>
                                    <li><i class="icofont-location-pin"></i> Location 210-27 Quadra, Market Street, Victoria Canada</li>
                                </ul>
                            </div>

                            <div class="job-inner-right">
                                <ul>
                                    <li><a routerLink="/create-account">Apply</a></li>
                                    <li><span>Part Time</span></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-6 mix wp web">
                    <div class="job-item">
                        <img src="assets/img/home-1/jobs/5.png" alt="Job">

                        <div class="job-inner align-items-center">
                            <div class="job-inner-left">
                                <h3>Digital Marketer</h3>
                                <a routerLink="/company-details">Hotelzo.com</a>
                                <ul>
                                    <li><i class="icofont-money-bag"></i>$20k - $25k</li>
                                    <li><i class="icofont-location-pin"></i>Location 210-27 Quadra, Market Street, Victoria Canada</li>
                                </ul>
                            </div>

                            <div class="job-inner-right">
                                <ul>
                                    <li><a routerLink="/create-account">Apply</a></li>
                                    <li><span>Intern</span></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-6 mix web ui">
                    <div class="job-item">
                        <img src="assets/img/home-1/jobs/6.png" alt="Job">

                        <div class="job-inner align-items-center">
                            <div class="job-inner-left">
                                <h3>Sales Manager</h3>
                                <a routerLink="/company-details">Gozuto.com</a>
                                <ul>
                                    <li><i class="icofont-money-bag"></i>$20k - $25k</li>
                                    <li><i class="icofont-location-pin"></i>Location 210-27 Quadra, Market Street, Victoria Canada</li>
                                </ul>
                            </div>

                            <div class="job-inner-right">
                                <ul>
                                    <li><a routerLink="/create-account">Apply</a></li>
                                    <li><span>Part Time</span></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-6 mix ux ui">
                    <div class="job-item">
                        <img src="assets/img/home-1/jobs/7.png" alt="Job">

                        <div class="job-inner align-items-center">
                            <div class="job-inner-left">
                                <h3>Web Developer</h3>
                                <a routerLink="/company-details">Udiza.com</a>
                                <ul>
                                    <li><i class="icofont-money-bag"></i>$20k - $25k</li>
                                    <li><i class="icofont-location-pin"></i>Location 210-27 Quadra, Market Street, Victoria Canada</li>
                                </ul>
                            </div>

                            <div class="job-inner-right">
                                <ul>
                                    <li><a routerLink="/create-account">Apply</a></li>
                                    <li><span>Full Time</span></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-6 mix branding web">
                    <div class="job-item">
                        <img src="assets/img/home-1/jobs/8.png" alt="Job">

                        <div class="job-inner align-items-center">
                            <div class="job-inner-left">
                                <h3>SEO</h3>
                                <a routerLink="/company-details">Oqota.com</a>
                                <ul>
                                    <li><i class="icofont-money-bag"></i>$20k - $25k</li>
                                    <li><i class="icofont-location-pin"></i>Location 210-27 Quadra, Market Street, Victoria Canada</li>
                                </ul>
                            </div>

                            <div class="job-inner-right">
                                <ul>
                                    <li><a routerLink="/create-account">Apply</a></li>
                                    <li><span>Part Time</span></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section-->

<!--div class="counter-area pt-100 pb-70">
    <div class="container">
        <div class="row">
            <div class="col-6 col-sm-3 col-lg-3">
                <div class="counter-item">
                    <i class="flaticon-employee"></i>
                    <h3><span class="counter">14</span>k+</h3>
                    <p>Job Available</p>
                </div>
            </div>

            <div class="col-6 col-sm-3 col-lg-3">
                <div class="counter-item">
                    <i class="flaticon-curriculum"></i>
                    <h3><span class="counter">18</span>k+</h3>
                    <p>CV Submitted</p>
                </div>
            </div>

            <div class="col-6 col-sm-3 col-lg-3">
                <div class="counter-item">
                    <i class="flaticon-enterprise"></i>
                    <h3><span class="counter">9</span>k+</h3>
                    <p>Companies</p>
                </div>
            </div>

            <div class="col-6 col-sm-3 col-lg-3">
                <div class="counter-item">
                    <i class="flaticon-businessman-paper-of-the-application-for-a-job"></i>
                    <h3><span class="counter">35</span>+</h3>
                    <p>Appointed to Job</p>
                </div>
            </div>
        </div>
    </div>
</div-->

<div class="popular-area pt-100 pb-100">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6">
                <div class="popular-item">
                    <div class="row align-items-center">
                        <div class="col-lg-7">
                            <img src="./assets/img/upload/home/342x514.png" alt="Popular" />
                        </div>

                        <div class="col-lg-5">
                            <div class="practice-inner">
                                <img
                                    src="./assets/img/upload/home/252x306.png"
                                    alt="Popular"
                                />
                                <img
                                    src="./assets/img/upload/home/252x213.png"
                                    alt="Popular"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-6">
                <div class="popular-item popular-right">
                    <div class="section-title text-start">
                        <h2>
                            Trouver des Fournisseurs Guinéens Validés Crédibles
                        </h2>
                    </div>
                    <p style="text-align: justify; font-size: 16px; color: black;">
                        Vous avez accès à une base de données fiable et
                        exhaustive des entreprises guinéennes compétitives tout
                        en étant en mesure de faire des offres de qualité.
                        Suivre l'impact socio-économique des investissements sur
                        le développement du contenu local en termes de création
                        d'emplois et de richesse.
                    </p>

                    <!-- <div class="row popular-wrap">
                        <div class="col-sm-6 col-lg-6">
                            <ul>
                                <li>
                                    <i class="flaticon-approved"></i> Trusted &
                                    Quality Job
                                </li>
                                <li>
                                    <i class="flaticon-no-money"></i> No Extra
                                    Charge
                                </li>
                            </ul>
                        </div>

                        <div class="col-sm-6 col-lg-6">
                            <ul>
                                <li>
                                    <i class="flaticon-enterprise"></i> Top
                                    Companies
                                </li>
                                <li>
                                    <i class="flaticon-employee"></i>
                                    International Job
                                </li>
                            </ul>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</div>

<!--div class="account-area account-area-two">
    <div class="container">
        <div class="row account-wrap">
            <div class="col-sm-6 col-lg-4">
                <div class="account-item">
                    <i class="flaticon-approved"></i>
                    <span>Register Your Account</span>
                </div>
            </div>

            <div class="col-sm-6 col-lg-4">
                <div class="account-item">
                    <i class="flaticon-cv"></i>
                    <span>Upload Your Resume</span>
                </div>
            </div>

            <div class="col-sm-6 offset-sm-3 offset-lg-0 col-lg-4">
                <div class="account-item account-last">
                    <i class="flaticon-customer-service"></i>
                    <span>Apply for Dream Job</span>
                </div>
            </div>
        </div>

        <div class="banner-btn">
            <a routerLink="/create-account">Create Your Profile</a>
            <a routerLink="/submit-resume">Upload Your CV</a>
        </div>
    </div>
</div-->



<section class="companies-area ptb-100" *ngIf="appSettingService.value != null">
    <div class="container">
        <div class="section-title">
            <h2 class="text-default">VOLUMES D'ACTIVITÉS</h2>
        </div>

        <div class="owl-theme owl-carousel mt-5">
            <div class="chart-item text-center">
                <canvas id="myChart1" width="600" height="300"></canvas>
                <span class="text-default text-center" style="text-align: center; font-size: 30px; font-weight: 700;">{{ format(appSettingService.value.total_supplier) }}</span>
                <p class="text-green text-center">Nombre de PME/PMI Profilées</p>
            </div>
<!--            <div class="chart-item text-center">-->
<!--                <canvas id="myChart2" width="600" height="300"></canvas>-->
<!--                <span class="text-default text-center" style="text-align: center; font-size: 30px; font-weight: 700;">1 806</span>-->
<!--                <p class="text-green text-center">Nombre de PME/PMI benchmarchées</p>-->
<!--            </div>-->
<!--            <div class="chart-item text-center">-->
<!--                <canvas id="myChart3" width="600" height="300"></canvas>-->
<!--                <span class="text-default text-center" style="text-align: center; font-size: 30px; font-weight: 700;">1 806</span>-->
<!--                <p class="text-green text-center">Nombre total d'emplois créés</p>-->
<!--            </div>-->
<!--            <div class="chart-item text-center">-->
<!--                <canvas id="myChart4" width="600" height="250"></canvas><br>-->
<!--                <span class="text-default text-center" style="text-align: center; font-size: 30px; font-weight: 700;">1 806</span>-->
<!--                <p class="text-green text-center">Nombre de PME/PMI accompagnées</p>-->
<!--            </div>-->
            <div class="chart-item text-center">
                <canvas id="myChart5" width="600" height="250"></canvas><br>
                <span class="text-default text-center" style="text-align: center; font-size: 30px; font-weight: 700;">{{ format(appSettingService.value.total_request) }}</span>
                <p class="text-green text-center">Nombre de mises en relation</p>
            </div>
<!--            <div class="chart-item text-center">-->
<!--                <canvas id="myChart6" width="600" height="250"></canvas><br>-->
<!--                <span class="text-default text-center" style="text-align: center; font-size: 30px; font-weight: 700;">1 806</span>-->
<!--                <p class="text-green text-center">Nombre de PME/PMI contractualisées</p>-->
<!--            </div>-->
            <div class="chart-item text-center">
                <canvas id="myChart7" width="600" height="250"></canvas><br>
                <h4 class="text-default text-center" style="text-align: center; font-size: 30px; font-weight: 700;">{{ format(appSettingService.value.total_buyer) }}</h4>
                <p class="text-green text-center">Nombre d'acheteurs trouvés</p>
            </div>
<!--            <div class="chart-item text-center">-->
<!--                <canvas id="myChart8" width="600" height="250"></canvas><br>-->
<!--                <span class="text-default text-center" style="text-align: center; font-size: 30px; font-weight: 700;">1 806</span>-->
<!--                <p class="text-green text-center">Nombre total de contrats</p>-->
<!--            </div>-->
            <div class="chart-item text-center">
                <canvas id="myChart9" width="600" height="250"></canvas><br>
                <span class="text-default text-center" style="text-align: center; font-size: 30px; font-weight: 700;">350 milliards de GNF</span>
                <p class="text-green text-center">Montant total des contrats (En milliards de GNF)</p>
            </div>

        </div>
    </div>
</section>

<!-- Services Section -->
<section class="services-section pt-100 pb-170 mb-100">
    <div class="container">
        <div class="section-header">
            <div class="header-icon">
                <i class="icofont-ui-settings"></i>
            </div>
            <h2>NOS SERVICES</h2>
            <p>Découvrez notre gamme complète de services pour accompagner votre développement</p>
        </div>

        <!-- Affichage des services avec effet shimmer pendant le chargement -->
        <div class="services-grid" *ngIf="loading">
            <div class="service-skeleton" *ngFor="let item of [].constructor(6)">
                <div class="skeleton-icon">
                    <p-skeleton shape="circle" size="60px" styleClass="mb-3"></p-skeleton>
                </div>
                <div class="skeleton-content">
                    <p-skeleton height="2rem" width="70%" styleClass="mb-3"></p-skeleton>
                    <p-skeleton height="1rem" width="100%" styleClass="mb-2"></p-skeleton>
                    <p-skeleton height="1rem" width="90%" styleClass="mb-2"></p-skeleton>
                    <p-skeleton height="1rem" width="80%"></p-skeleton>
                </div>
            </div>
        </div>

        <!-- Affichage des services une fois chargés -->
        <div class="services-grid" *ngIf="!loading && services && services.length > 0">
            <div class="service-card" *ngFor="let service of services; let i = index" 
                 >
                <div class="card-header">
                    <div class="service-icon">
                        <i [ngClass]="service.icon"></i>
                    </div>
                    <h3>{{ service.name }}</h3>
                </div>
                <div class="card-content">
                    <div class="service-description" [innerHTML]="service.short_description"></div>
                    <div class="service-actions">
                        <a [routerLink]="['/services', service.slug]" class="read-more-btn">
                            <i class="icofont-arrow-right"></i>
                            <span>En savoir plus</span>
                        </a>
                    </div>
                </div>
                <div class="card-bg"></div>
            </div>
        </div>
    </div>
</section>

<section class="blog-area pt-170 pb-170" style="margin-top: 100px !important;">
    <div class="container">
        <div class="section-title">
            <h2>NOS DERNIÈRES ACTUALITÉS</h2>
        </div>

        <div class="row" *ngIf="!articles">

            <div class="col-sm-6 col-lg-4" *ngFor="let i of [0,1,2,3,4,5]">
                <div class="blog-item">
                    <div class="blog-top">
                        <p-skeleton height="278px" width="100%" styleClass="mb-2"></p-skeleton>
                        <p-skeleton height="1.5rem" width="40%"></p-skeleton>
                    </div>

                    <div class="blog-bottom">
                        <h3><p-skeleton height="2rem" width="90%"></p-skeleton></h3>
                        <ul>
                            <li><p-skeleton height="1.5rem" width="30%"></p-skeleton></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <div class="row" *ngIf="articles">
            <div class="col-sm-6 col-md-4 col-lg-4" *ngFor="let article of articles">
                <div class="blog-item wow fadeInUp" data-wow-delay=".3s">
                    <div class="blog-top">
                        <a routerLink="blog/{{ article.slug }}"><img [src]="article.media" [alt]="article.title"></a>
                        <span>{{ article.publishon_on|date:'d MMMM yyyy' }}</span>
                    </div>

                    <div class="blog-bottom">
                        <h5 class="text-green"><a routerLink="blog/{{ article.slug }}"> {{ article.title }} </a></h5>
                        <ul>
                            <li><a routerLink="blog/{{ article.slug }}">Lire Plus<i class="icofont-simple-right"></i></a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Nouvelle section: Mission et Vision de la BSTP -->
<!--section class="mission-vision-area pt-100 pb-70 bg-light">
    <div class="container">
        <div class="section-title text-center mb-5" data-aos="fade-up">
            <h2 class="animated-heading">NOTRE MISSION & VISION</h2>
            <p class="text-muted animated-subtitle">La Bourse des Sous-Traitance et de Partenariats de Guinée</p>
        </div>
        
        <div class="row">
            <div class="col-lg-6 mb-4" data-aos="fade-right" data-aos-delay="200">
                <div class="mission-card h-100 bg-white p-4 rounded-3 shadow-sm border-start border-4 border-success interactive-card">
                    <div class="d-flex align-items-center mb-3">
                        <div class="mission-icon bg-success text-white rounded-circle d-flex align-items-center justify-content-center me-3" style="width: 60px; height: 60px;">
                            <i class="flaticon-brand-target" style="font-size: 24px;"></i>
                        </div>
                        <h4 class="mb-0 text-success animated-text">Notre Mission</h4>
                    </div>
                    <p class="text-muted mb-0 mission-description" style="text-align: justify; line-height: 1.8;">
                        <span class="reveal-text">Faciliter l'accès aux marchés publics et privés pour les PME/PMI guinéennes, 
                        promouvoir la sous-traitance locale et créer des partenariats durables entre 
                        les entreprises locales et les multinationales opérant en Guinée.</span>
                    </p>
                </div>
            </div>
            
            <div class="col-lg-6 mb-4" data-aos="fade-left" data-aos-delay="400">
                <div class="vision-card h-100 bg-white p-4 rounded-3 shadow-sm border-start border-4 border-primary interactive-card">
                    <div class="d-flex align-items-center mb-3">
                        <div class="vision-icon bg-primary text-white rounded-circle d-flex align-items-center justify-content-center me-3" style="width: 60px; height: 60px;">
                            <i class="flaticon-eye" style="font-size: 24px;"></i>
                        </div>
                        <h4 class="mb-0 text-primary animated-text">Notre Vision</h4>
                    </div>
                    <p class="text-muted mb-0 vision-description" style="text-align: justify; line-height: 1.8;">
                        <span class="reveal-text">Devenir la plateforme de référence pour le développement économique 
                        de la Guinée en favorisant l'émergence d'un tissu entrepreneurial 
                        compétitif et innovant, contribuant ainsi à la création d'emplois 
                        et à la diversification de l'économie nationale.</span>
                    </p>
                </div>
            </div>
        </div>
    </div>
</section-->

<!-- Section: Valeurs de la BSTP -->
<section class="values-area pt-100 pb-70">
    <div class="container">
        <div class="section-title text-center mb-5">
            <h2>NOS VALEURS FONDAMENTALES</h2>
        </div>
        
        <div class="row">
            <div class="col-lg-3 col-md-6 mb-4">
                <div class="value-card text-center p-4 h-100 bg-white rounded-3 shadow-sm">
                    <div class="value-icon mb-3">
                        <i class="icofont-handshake-deal text-success" style="font-size: 48px;"></i>
                    </div>
                    <h5 class="text-success mb-3">Confiance</h5>
                    <p class="text-muted mb-0" style="text-align: justify;">
                        Bâtir des relations durables basées sur la transparence et la fiabilité 
                        entre tous nos partenaires.
                    </p>
                </div>
            </div>
            
            <div class="col-lg-3 col-md-6 mb-4">
                <div class="value-card text-center p-4 h-100 bg-white rounded-3 shadow-sm">
                    <div class="value-icon mb-3">
                        <i class="icofont-file-text text-primary" style="font-size: 48px;"></i>
                    </div>
                    <h5 class="text-primary mb-3">Excellence</h5>
                    <p class="text-muted mb-0" style="text-align: justify;">
                        Promouvoir les meilleures pratiques et standards de qualité 
                        dans tous nos services.
                    </p>
                </div>
            </div>
            
            <div class="col-lg-3 col-md-6 mb-4">
                <div class="value-card text-center p-4 h-100 bg-white rounded-3 shadow-sm">
                    <div class="value-icon mb-3">
                        <i class="icofont-brand-techcrunch text-warning" style="font-size: 48px;"></i>
                    </div>
                    <h5 class="text-warning mb-3">Innovation</h5>
                    <p class="text-muted mb-0" style="text-align: justify;">
                        Encourager l'innovation technologique et organisationnelle 
                        pour améliorer la compétitivité.
                    </p>
                </div>
            </div>
            
            <div class="col-lg-3 col-md-6 mb-4">
                <div class="value-card text-center p-4 h-100 bg-white rounded-3 shadow-sm">
                    <div class="value-icon mb-3">
                        <i class="icofont-oscommerce text-danger" style="font-size: 48px;"></i>
                    </div>
                    <h5 class="text-danger mb-3">Inclusion</h5>
                    <p class="text-muted mb-0" style="text-align: justify;">
                        Assurer l'égalité des chances et l'inclusion de toutes 
                        les entreprises, quelle que soit leur taille.
                    </p>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Section: Avantages de la BSTP -->
<section class="advantages-area pt-100 pb-70 bg-light">
    <div class="container">
        <div class="section-title text-center mb-5">
            <h2>POURQUOI CHOISIR LA BSTP ?</h2>
        </div>
        
        <div class="row">
            <div class="col-lg-4 mb-4">
                <div class="advantage-card bg-white p-4 rounded-3 shadow-sm h-100">
                    <div class="advantage-icon mb-3 text-center">
                        <i class="icofont-network text-success" style="font-size: 64px;"></i>
                    </div>
                    <h4 class="text-center text-success mb-3">Réseau National</h4>
                    <ul class="list-unstyled">
                        <li class="mb-2"><i class="icofont-check-circled text-success me-2"></i>Accès à plus de 1000 entreprises validées</li>
                        <li class="mb-2"><i class="icofont-check-circled text-success me-2"></i>Connexion avec les multinationales</li>
                        <li class="mb-2"><i class="icofont-check-circled text-success me-2"></i>Partenariats stratégiques</li>
                        <li class="mb-2"><i class="icofont-check-circled text-success me-2"></i>Opportunités d'affaires exclusives</li>
                    </ul>
                </div>
            </div>
            
            <div class="col-lg-4 mb-4">
                <div class="advantage-card bg-white p-4 rounded-3 shadow-sm h-100">
                    <div class="advantage-icon mb-3 text-center">
                        <i class="icofont-certificate text-primary" style="font-size: 64px;"></i>
                    </div>
                    <h4 class="text-center text-primary mb-3">Accompagnement Qualité</h4>
                    <ul class="list-unstyled">
                        <li class="mb-2"><i class="icofont-check-circled text-primary me-2"></i>Formation et certification</li>
                        <li class="mb-2"><i class="icofont-check-circled text-primary me-2"></i>Conformité aux normes internationales</li>
                        <li class="mb-2"><i class="icofont-check-circled text-primary me-2"></i>Support technique continu</li>
                        <li class="mb-2"><i class="icofont-check-circled text-primary me-2"></i>Audit et évaluation régulière</li>
                    </ul>
                </div>
            </div>
            
            <div class="col-lg-4 mb-4">
                <div class="advantage-card bg-white p-4 rounded-3 shadow-sm h-100">
                    <div class="advantage-icon mb-3 text-center">
                        <i class="icofont-chart-growth text-warning" style="font-size: 64px;"></i>
                    </div>
                    <h4 class="text-center text-warning mb-3">Croissance Garantie</h4>
                    <ul class="list-unstyled">
                        <li class="mb-2"><i class="icofont-check-circled text-warning me-2"></i>Augmentation du chiffre d'affaires</li>
                        <li class="mb-2"><i class="icofont-check-circled text-warning me-2"></i>Création d'emplois locaux</li>
                        <li class="mb-2"><i class="icofont-check-circled text-warning me-2"></i>Développement des compétences</li>
                        <li class="mb-2"><i class="icofont-check-circled text-warning me-2"></i>Expansion vers de nouveaux marchés</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Section: Témoignages -->
<section class="testimonials-area pt-100 pb-70">
    <div class="container">
        <div class="section-title text-center mb-5">
            <h2>TÉMOIGNAGES DE NOS PARTENAIRES</h2>
        </div>
        
        <div class="row">
            <div class="col-lg-4 mb-4">
                <div class="testimonial-card bg-white p-4 rounded-3 shadow-sm h-100">
                    <div class="testimonial-content mb-3">
                        <p class="text-muted mb-0" style="text-align: justify; font-style: italic;">
                            "Grâce à la BSTP, notre entreprise a pu accéder à des marchés 
                            que nous n'aurions jamais pu atteindre seuls. L'accompagnement 
                            technique nous a permis d'améliorer significativement nos standards."
                        </p>
                    </div>
                    <div class="testimonial-author d-flex align-items-center">
                        <div class="author-avatar bg-success rounded-circle me-3 d-flex align-items-center justify-content-center" style="width: 50px; height: 50px;">
                            <i class="icofont-user text-white"></i>
                        </div>
                        <div>
                            <h6 class="mb-0 text-success">Mamadou Diallo</h6>
                            <small class="text-muted">Directeur Général, Tech Solutions Guinée</small>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="col-lg-4 mb-4">
                <div class="testimonial-card bg-white p-4 rounded-3 shadow-sm h-100">
                    <div class="testimonial-content mb-3">
                        <p class="text-muted mb-0" style="text-align: justify; font-style: italic;">
                            "La BSTP a transformé notre façon de faire des affaires. 
                            Nous avons trouvé des fournisseurs locaux de qualité et 
                            contribué au développement économique de la Guinée."
                        </p>
                    </div>
                    <div class="testimonial-author d-flex align-items-center">
                        <div class="author-avatar bg-primary rounded-circle me-3 d-flex align-items-center justify-content-center" style="width: 50px; height: 50px;">
                            <i class="icofont-user text-white"></i>
                        </div>
                        <div>
                            <h6 class="mb-0 text-primary">Fatoumata Bah</h6>
                            <small class="text-muted">Responsable Achats, Mining Corp Guinée</small>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="col-lg-4 mb-4">
                <div class="testimonial-card bg-white p-4 rounded-3 shadow-sm h-100">
                    <div class="testimonial-content mb-3">
                        <p class="text-muted mb-0" style="text-align: justify; font-style: italic;">
                            "L'approche professionnelle de la BSTP et leur réseau 
                            d'entreprises validées nous ont permis de développer 
                            notre activité de manière significative."
                        </p>
                    </div>
                    <div class="testimonial-author d-flex align-items-center">
                        <div class="author-avatar bg-warning rounded-circle me-3 d-flex align-items-center justify-content-center" style="width: 50px; height: 50px;">
                            <i class="icofont-user text-white"></i>
                        </div>
                        <div>
                            <h6 class="mb-0 text-warning">Ibrahima Camara</h6>
                            <small class="text-muted">PDG, Construction Plus Guinée</small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Section: Statistiques Avancées -->
<section class="advanced-stats-area pt-100 pb-70 bg-dark text-white">
    <div class="container">
        <div class="section-title text-center mb-5">
            <h2 class="text-white">IMPACT SOCIO-ÉCONOMIQUE</h2>
            <p class="text-light">La contribution de la BSTP au développement de la Guinée</p>
        </div>
        
        <div class="row">
            <div class="col-lg-3 col-md-6 mb-4">
                <div class="stat-card text-center p-4">
                    <div class="stat-icon mb-3">
                        <i class="flaticon-employee text-success" style="font-size: 35px;"></i>
                    </div>
                    <h3 class="text-success mb-2">+15,000</h3>
                    <p class="mb-0">Emplois Créés</p>
                </div>
            </div>
            
            <div class="col-lg-3 col-md-6 mb-4">
                <div class="stat-card text-center p-4">
                    <div class="stat-icon mb-3">
                        <i class="icofont-money-bag text-primary" style="font-size: 48px;"></i>
                    </div>
                    <h3 class="text-primary mb-2">+500M GNF</h3>
                    <p class="mb-0">Chiffre d'Affaires Généré</p>
                </div>
            </div>
            
            <div class="col-lg-3 col-md-6 mb-4">
                <div class="stat-card text-center p-4">
                    <div class="stat-icon mb-3">
                        <i class="icofont-hand-power text-warning" style="font-size: 48px;"></i>
                    </div>
                    <h3 class="text-warning mb-2">+2,500</h3>
                    <p class="mb-0">Partenariats Signés</p>
                </div>
            </div>
            
            <div class="col-lg-3 col-md-6 mb-4">
                <div class="stat-card text-center p-4">
                    <div class="stat-icon mb-3">
                        <i class="icofont-brand-target text-danger" style="font-size: 48px;"></i>
                    </div>
                    <h3 class="text-danger mb-2">+85%</h3>
                    <p class="mb-0">Taux de Satisfaction</p>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Section: Secteurs d'Activité -->
<section class="sectors-area pt-100 pb-70">
    <div class="container">
        <div class="section-title text-center mb-5">
            <h2>SECTEURS D'ACTIVITÉ</h2>
            <p class="text-muted">La BSTP couvre tous les secteurs économiques de la Guinée</p>
        </div>
        
        <div class="row">
            <div class="col-lg-3 col-md-6 mb-4">
                <div class="sector-card bg-white p-4 rounded-3 shadow-sm h-100 text-center">
                    <div class="sector-icon mb-3">
                        <i class="icofont-mining text-warning" style="font-size: 48px;"></i>
                    </div>
                    <h5 class="text-warning mb-3">Mines & Métallurgie</h5>
                    <p class="text-muted mb-0" style="text-align: justify;">
                        Services de sous-traitance pour l'industrie minière, 
                        fourniture d'équipements et services techniques.
                    </p>
                </div>
            </div>
            
            <div class="col-lg-3 col-md-6 mb-4">
                <div class="sector-card bg-white p-4 rounded-3 shadow-sm h-100 text-center">
                    <div class="sector-icon mb-3">
                        <i class="icofont-under-construction-alt text-primary" style="font-size: 48px;"></i>
                    </div>
                    <h5 class="text-primary mb-3">BTP & Construction</h5>
                    <p class="text-muted mb-0" style="text-align: justify;">
                        Travaux de construction, rénovation et maintenance 
                        d'infrastructures publiques et privées.
                    </p>
                </div>
            </div>
            
            <div class="col-lg-3 col-md-6 mb-4">
                <div class="sector-card bg-white p-4 rounded-3 shadow-sm h-100 text-center">
                    <div class="sector-icon mb-3">
                        <i class="icofont-thunder-light text-success" style="font-size: 48px;"></i>
                    </div>
                    <h5 class="text-success mb-3">Énergie & Électricité</h5>
                    <p class="text-muted mb-0" style="text-align: justify;">
                        Production, distribution et maintenance des systèmes 
                        énergétiques et électriques.
                    </p>
                </div>
            </div>
            
            <div class="col-lg-3 col-md-6 mb-4">
                <div class="sector-card bg-white p-4 rounded-3 shadow-sm h-100 text-center">
                    <div class="sector-icon mb-3">
                        <i class="icofont-bus text-danger" style="font-size: 48px;"></i>
                    </div>
                    <h5 class="text-danger mb-3">Transport & Logistique</h5>
                    <p class="text-muted mb-0" style="text-align: justify;">
                        Services de transport, logistique et distribution 
                        pour tous types de marchandises.
                    </p>
                </div>
            </div>
            
            <div class="col-lg-3 col-md-6 mb-4">
                <div class="sector-card bg-white p-4 rounded-3 shadow-sm h-100 text-center">
                    <div class="sector-icon mb-3">
                        <i class="icofont-architecture-alt text-info" style="font-size: 48px;"></i>
                    </div>
                    <h5 class="text-info mb-3">Technologies & IT</h5>
                    <p class="text-muted mb-0" style="text-align: justify;">
                        Solutions informatiques, développement logiciel 
                        et services technologiques innovants.
                    </p>
                </div>
            </div>
            
            <div class="col-lg-3 col-md-6 mb-4">
                <div class="sector-card bg-white p-4 rounded-3 shadow-sm h-100 text-center">
                    <div class="sector-icon mb-3">
                        <i class="icofont-cauli-flower text-success" style="font-size: 48px;"></i>
                    </div>
                    <h5 class="text-success mb-3">Agriculture & Agroalimentaire</h5>
                    <p class="text-muted mb-0" style="text-align: justify;">
                        Production agricole, transformation alimentaire 
                        et services agro-industriels.
                    </p>
                </div>
            </div>
            
            <div class="col-lg-3 col-md-6 mb-4">
                <div class="sector-card bg-white p-4 rounded-3 shadow-sm h-100 text-center">
                    <div class="sector-icon mb-3">
                        <i class="icofont-doctor text-danger" style="font-size: 48px;"></i>
                    </div>
                    <h5 class="text-danger mb-3">Santé & Pharmacie</h5>
                    <p class="text-muted mb-0" style="text-align: justify;">
                        Services médicaux, fournitures pharmaceutiques 
                        et équipements de santé.
                    </p>
                </div>
            </div>
            
            <div class="col-lg-3 col-md-6 mb-4">
                <div class="sector-card bg-white p-4 rounded-3 shadow-sm h-100 text-center">
                    <div class="sector-icon mb-3">
                        <i class="icofont-education text-warning" style="font-size: 48px;"></i>
                    </div>
                    <h5 class="text-warning mb-3">Formation & Éducation</h5>
                    <p class="text-muted mb-0" style="text-align: justify;">
                        Formation professionnelle, éducation et 
                        développement des compétences.
                    </p>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Section: Partenaires et Organismes de Soutien -->
<section class="partners-area pt-100 pb-70 bg-light">
    <div class="container">
        <div class="section-title text-center mb-5">
            <h2>NOS PARTENAIRES STRATÉGIQUES</h2>
            <p class="text-muted">La BSTP travaille en collaboration avec des institutions de renom</p>
        </div>
        
        <div class="row">
            <div class="col-lg-4 mb-4">
                <div class="partner-card bg-white p-4 rounded-3 shadow-sm h-100">
                    <div class="partner-header d-flex align-items-center mb-3">
                        <div class="partner-icon bg-primary text-white rounded-circle me-3 d-flex align-items-center justify-content-center" style="width: 60px; height: 60px;">
                            <i class="icofont-company" style="font-size: 24px;"></i>
                        </div>
                        <div>
                            <h5 class="mb-0 text-primary">Gouvernement Guinéen</h5>
                            <small class="text-muted">Institution Publique</small>
                        </div>
                    </div>
                    <p class="text-muted mb-0" style="text-align: justify;">
                        Partenaire institutionnel principal, le gouvernement guinéen 
                        soutient activement la BSTP dans sa mission de développement 
                        économique et de création d'emplois.
                    </p>
                </div>
            </div>
            
            <div class="col-lg-4 mb-4">
                <div class="partner-card bg-white p-4 rounded-3 shadow-sm h-100">
                    <div class="partner-header d-flex align-items-center mb-3">
                        <div class="partner-icon bg-success text-white rounded-circle me-3 d-flex align-items-center justify-content-center" style="width: 60px; height: 60px;">
                            <i class="icofont-bank" style="font-size: 24px;"></i>
                        </div>
                        <div>
                            <h5 class="mb-0 text-success">Banque Centrale</h5>
                            <small class="text-muted">Institution Financière</small>
                        </div>
                    </div>
                    <p class="text-muted mb-0" style="text-align: justify;">
                        Partenaire financier stratégique, la Banque Centrale 
                        facilite l'accès au crédit et aux services bancaires 
                        pour les entreprises membres de la BSTP.
                    </p>
                </div>
            </div>
            
            <div class="col-lg-4 mb-4">
                <div class="partner-card bg-white p-4 rounded-3 shadow-sm h-100">
                    <div class="partner-header d-flex align-items-center mb-3">
                        <div class="partner-icon bg-warning text-white rounded-circle me-3 d-flex align-items-center justify-content-center" style="width: 60px; height: 60px;">
                            <i class="icofont-world" style="font-size: 24px;"></i>
                        </div>
                        <div>
                            <h5 class="mb-0 text-warning">Organisations Internationales</h5>
                            <small class="text-muted">Partenaires Internationaux</small>
                        </div>
                    </div>
                    <p class="text-muted mb-0" style="text-align: justify;">
                        Collaboration avec des organisations internationales 
                        pour le transfert de technologies et le renforcement 
                        des capacités des entreprises locales.
                    </p>
                </div>
            </div>
            
            <div class="col-lg-4 mb-4">
                <div class="partner-card bg-white p-4 rounded-3 shadow-sm h-100">
                    <div class="partner-header d-flex align-items-center mb-3">
                        <div class="partner-icon bg-info text-white rounded-circle me-3 d-flex align-items-center justify-content-center" style="width: 60px; height: 60px;">
                            <i class="icofont-university" style="font-size: 24px;"></i>
                        </div>
                        <div>
                            <h5 class="mb-0 text-info">Institutions Académiques</h5>
                            <small class="text-muted">Formation & Recherche</small>
                        </div>
                    </div>
                    <p class="text-muted mb-0" style="text-align: justify;">
                        Partenariats avec les universités et centres de formation 
                        pour le développement des compétences et la recherche 
                        appliquée au secteur privé.
                    </p>
                </div>
            </div>
            
            <div class="col-lg-4 mb-4">
                <div class="partner-card bg-white p-4 rounded-3 shadow-sm h-100">
                    <div class="partner-header d-flex align-items-center mb-3">
                        <div class="partner-icon bg-danger text-white rounded-circle me-3 d-flex align-items-center justify-content-center" style="width: 60px; height: 60px;">
                            <i class="icofont-building" style="font-size: 24px;"></i>
                        </div>
                        <div>
                            <h5 class="mb-0 text-danger">Chambres de Commerce</h5>
                            <small class="text-muted">Organisations Professionnelles</small>
                        </div>
                    </div>
                    <p class="text-muted mb-0" style="text-align: justify;">
                        Collaboration étroite avec les chambres de commerce 
                        pour la promotion du commerce et de l'industrie 
                        en Guinée.
                    </p>
                </div>
            </div>
            
            <div class="col-lg-4 mb-4">
                <div class="partner-card bg-white p-4 rounded-3 shadow-sm h-100">
                    <div class="partner-header d-flex align-items-center mb-3">
                        <div class="partner-icon bg-secondary text-white rounded-circle me-3 d-flex align-items-center justify-content-center" style="width: 60px; height: 60px;">
                            <i class="flaticon-enterprise" style="font-size: 24px;"></i>
                        </div>
                        <div>
                            <h5 class="mb-0 text-secondary">Multinationales</h5>
                            <small class="text-muted">Partenaires Privés</small>
                        </div>
                    </div>
                    <p class="text-muted mb-0" style="text-align: justify;">
                        Partenariats avec les grandes entreprises internationales 
                        pour faciliter l'accès aux marchés et aux opportunités 
                        d'affaires pour les PME locales.
                    </p>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Section: Call to Action Final -->
<section class="final-cta-area pt-100 pb-70 bg-success text-white">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-8">
                <div class="cta-content">
                    <h2 class="text-white mb-3">Prêt à Rejoindre la BSTP ?</h2>
                    <p class="text-light mb-4" style="text-align: justify; font-size: 18px;">
                        Rejoignez des milliers d'entreprises qui ont déjà transformé leur destin 
                        grâce à la Bourse des Sous-Traitance et de Partenariats de Guinée. 
                        Votre succès commence ici !
                    </p>
                    <div class="cta-buttons">
                        <a class="btn btn-light btn-lg me-3" routerLink="/create-account">
                            <i class="icofont-swoosh-right me-2"></i>Rejoindre Maintenant
                        </a>
                        <a class="btn btn-outline-light btn-lg" routerLink="/contact">
                            <i class="icofont-phone me-2"></i>Nous Contacter
                        </a>
                    </div>
                </div>
            </div>
            
            <div class="col-lg-4">
                <div class="cta-image text-center">
                    <i class="icofont-check-circled text-white" style="font-size: 120px; opacity: 0.3;"></i>
                </div>
            </div>
        </div>
    </div>
</section>


